<template lang="pug">
  .login-container
    b-container
      b-row.justify-content-center
        b-col(md="5", xl="4", style="text-align:center;")
          h3 Recuperar contraseña
          .text-help.mb-4 Te enviaremos un correo con un link para cambiar tu contraseña
          validation-observer(v-slot="{ invalid, handleSubmit }")
            b-form(style="text-align:left;", @submit.prevent="handleSubmit(recoverPassword)")
              validation-provider(v-slot="{ errors, valid }", rules="required|email", name="Correo")
                b-form-group.mb-4(label="Correo", label-for="email-input")
                  b-form-input(id="email-input", type="email", placeholder="Ingresa tu correo", v-model="form.email", name="Correo", :state="errors[0] ? false : valid")
                  b-form-invalid-feedback {{ errors[0] }}
              b-button.mb-2(variant="primary", block, type="submit", :disabled="loading || invalid")
                span.mr-2(v-if="!loading", style="vertical-align:middle;") Enviar
                b-spinner(v-else, small, type="grow", style="vertical-align:middle;")
          b-link(:to="{name: 'login'}", style="font-size:13px;") Iniciar sesión
</template>

<script>
const WARNING_MESSAGE = 'Si el correo electrónico es válido, por favor revise su bandeja de entrada.'
const ERROR_MESSAGE = 'Has superado el numero máximo de intentos, por favor intentalo mas tarde.'

export default {
  data () {
    return {
      form: {
        email: ''
      },
      loading: false
    }
  },
  methods: {
    recoverPassword (event) {
      const self = this

      this.loading = true
      this.$store.dispatch('auth/recovery', {
        params: {
          ...self.form,
          service: 'konverza'
        },
        callback: res => {
          self.loading = false

          if (res.error) {
            self.$message.error(ERROR_MESSAGE)
          } else {
            self.$message.warning({
              message: WARNING_MESSAGE,
              duration: 1000 * 60,
              showClose: true
            })
          }

          self.$router.push({ name: 'login' }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    min-height: 0;
    border-top: 2px solid #0e5ccf;

    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
